import React from 'react'
import { Link } from 'react-router-dom'
import { useTheme } from '../Context/ThemeContext'
import Layout from "../Layout"

function NotFound() {

    const { primaryColor, secondaryColor, theme, selectedColor, colors } = useTheme();

    return (
        <Layout>
            <section className="flex items-center px-16">
                <div className="container flex flex-col items-center justify-center px-5 mx-auto my-8">
                    <div className="max-w-md text-center">
                        <h2 className={`mb-8 font-extrabold text-9xl ${primaryColor} dark:${secondaryColor}`}>
                            <span className="sr-only">Error</span>404
                        </h2>
                        <p className={`mb-10 text-2xl font-semibold md:text-2xl ${secondaryColor}`}>Sorry, we couldn't find this page.</p>
                        <Link to="/" rel="noopener noreferrer" className={`px-8 py-3 font-semibold rounded ${secondaryColor} ${colors[theme].colors[selectedColor].bgPrimary}`}>Back to Home</Link>
                    </div>
                </div>
            </section>
        </Layout>
    )
}

export default NotFound